import { createFileRoute } from '@tanstack/react-router';
import { type ReactNode, useState } from 'react';
import { BoardPage } from '../../components/BoardPage.js';
import { CreativesBoard } from '../../components/creatives/CreativesBoard.js';
import { DEFAULT_TOP_METRICS } from '../../components/creatives/data/selection.js';
import { TopMetricsStrip } from '../../components/creatives/TopMetricsStrip.js';
import { WorkflowsFilterBar } from '../../components/filters/WorkflowsFilterBar.js';
import {
  type CreativeDetailSearch,
  validateCreativeDetailSearch,
} from '../../lib/creative-detail-search.js';
import {
  type FilterFieldsSearch,
  filtersToScope,
  type MetricState,
  useFilterSearch,
  validateFilterSearch,
} from '../../lib/filter-search.js';
import { type MediaSearch, validateMediaSearch } from '../../lib/media-search.js';

type ExploreSearch = MediaSearch &
  FilterFieldsSearch &
  CreativeDetailSearch & { metric?: MetricState };

function ExplorePage(): ReactNode {
  const { added } = useFilterSearch('/explore');
  const [chosenTopMetrics, setChosenTopMetrics] = useState<string[]>(() => [
    ...DEFAULT_TOP_METRICS,
  ]);

  return (
    <BoardPage
      route="/explore"
      active="explore"
      topBar={({ scope, applyScope }) => (
        <WorkflowsFilterBar bar="explore" to="/explore" scope={scope} onScopeChange={applyScope} />
      )}
    >
      {({ accountIds, dateWindow, scope }) => {
        const merged = {
          ...filtersToScope(added),
          ...(scope.creativeType.length ? { creativeType: scope.creativeType } : {}),
        };
        const filters = Object.keys(merged).length ? merged : undefined;
        return (
          <>
            <TopMetricsStrip
              accountIds={accountIds}
              dateWindow={dateWindow}
              filters={filters}
              chosen={chosenTopMetrics}
              onChosenChange={setChosenTopMetrics}
              onSelectionChange={() => {}}
              leadingKpi={scope.leadingKpi}
              surface="explore"
            />
            <CreativesBoard
              accountIds={accountIds}
              dateWindow={dateWindow}
              filters={filters}
              route="/explore"
              leadingKpi={scope.leadingKpi}
            />
          </>
        );
      }}
    </BoardPage>
  );
}

export const Route = createFileRoute('/explore/')({
  validateSearch: (search: Record<string, unknown>): ExploreSearch => ({
    ...validateMediaSearch(search),
    ...validateFilterSearch(search),
    ...validateCreativeDetailSearch(search),
  }),
  component: ExplorePage,
});
